import React, { useState, useEffect } from 'react'
import {
  TextField,
  Grid,
  Button,
  MenuItem,
  Card,
  CardContent,
  Typography
} from '@material-ui/core'
import DimensionsListInPage from '../../orderPack/dimensionsListInPage'
import RonadIcons from '../../../components/iconComponent'

const DimensionInputs = (props: any) => {
  const [count, setCount] = useState('')
  const [weight, setWeight] = useState('')
  const [size, setSize] = useState('')

  const checkButtonDisabled = () => {
    return !size || !weight || !count
  }

  const { setDimensions, dimensions, isParcelPackageRequired } = props
  // const { errors, setValue, getValues, register, control } = props.form

  const addDimensions = () => {
    const newDimension = {
      id: Date.now(),
      count,
      length: size,
      width: size,
      height: size,
      weight
    }
    setDimensions([...dimensions, newDimension])
    setCount('')
    setSize('')
    setWeight('')
  }

  // useEffect(() => {
  //   register('dimensions', {
  //     validate: (value: any) => {
  //       if (!isParcelPackageRequired && dimensions.length === 0) {
  //         return 'در جمع‌آوری اقتصادی انتخاب بسته محموله الزامی می‌باشد.'
  //       }
  //       return true
  //     }
  //   })
  // }, [register, isParcelPackageRequired, dimensions])

  return (
    <Card style={{ marginBottom: '24px' }}>
      <CardContent>
        <Grid container spacing={2} justifyContent='flex-start'>
          <Grid item xs={3}>
            <TextField
              variant='outlined'
              fullWidth
              id='count'
              name='count'
              value={count}
              onChange={(e) => setCount(e.target.value)}
              label='تعداد'
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              variant='outlined'
              fullWidth
              id='weight'
              name='weight'
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              label='وزن(گرم)'
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              variant='outlined'
              select
              fullWidth
              value={size}
              label='سایز بسته‌بندی'
              onChange={(e) => setSize(e.target.value)}
            >
              <MenuItem value={'10'} id='time1'>
                سایز 0 تا 2 پستی
              </MenuItem>
              <MenuItem value={'20'} id='time2'>
                سایز 2 تا 5 پستی
              </MenuItem>
              <MenuItem value={'30'} id='time3'>
                سایز 5 تا 9 پستی
              </MenuItem>
              <MenuItem value={'33'} id='time4'>
                نا متعارف
              </MenuItem>
            </TextField>
          </Grid>
          <Grid item>
            <Button
              style={{ height: '100%' }}
              variant='outlined'
              color='primary'
              size='large'
              onClick={addDimensions}
              disabled={checkButtonDisabled()}
              startIcon={
                <RonadIcons name='plusCircleOutline' className='text-primary' />
              }
              id='addProduct'
            >
              {'افزودن بسته به محموله'}
            </Button>
          </Grid>

          {dimensions?.length !== 0 && (
            <Grid item xs={12}>
              <DimensionsListInPage
                setDimensions={setDimensions}
                data={dimensions}
                modal
              />
            </Grid>
          )}
          {isParcelPackageRequired && (
            <Grid container className='notif'>
              <RonadIcons
                name='information'
                size={0.7}
                style={{ color: '#43778E' }}
              />
              <Typography style={{ marginRight: '10px', fontSize: '14px' }}>
                وارد کردن اندازه بسته‌ها در جمع‌آوری توسط روناد اجباری است.
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  )
}

export default DimensionInputs
